/**
 * Zakres mocy falownika wyprowadzony z mocy instalacji PV.
 *
 * REGUŁA: falownik dobiera się MNIEJSZY LUB RÓWNY mocy modułów, typowo 0,8–1,0 × kWp.
 * Instalacja 7 kWp pracuje spokojnie na falowniku 6 kW, bo moc szczytową z tabliczki
 * moduły osiągają w Polsce przez kilka godzin w roku — przez resztę czasu falownik
 * dobrany „co do kilowata" po prostu stoi niedociążony i kosztuje więcej.
 *
 * GRANICE W PEŁNYCH KILOWATACH — obie w dół i w górę od zakresu teoretycznego:
 * dolna zaokrąglana w DÓŁ, górna w GÓRĘ. Wcześniej chodziły po połówkach
 * i asystent proponował „od 3,5 kW", czego w katalogu prawie nie ma: falowniki
 * sprzedaje się w pełnych kilowatach (3, 5, 6, 8, 10), a połówki to pojedyncze
 * modele. Zakres jest FILTREM, nie zaleceniem — poszerzenie go na obie strony
 * wpuszcza więcej ofert do porównania, a nie zawęża wyboru.
 *
 * Konsekwencja dolnego zaokrąglenia: przy niektórych mocach dolna granica
 * schodzi zauważalnie poniżej 0,8 × kWp (4,95 kWp → 3 kW zamiast 3,96).
 * To świadome — falownik mniejszy od modułów jest normą, a nie usterką,
 * i to silnik doboru wybiera z zakresu, nie użytkownik.
 */
export const zakresFalownika = (kwp) => {
  const moc = Number(kwp);
  if (!Number.isFinite(moc) || moc <= 0) return null;
  return {
    min: Math.max(1, Math.floor(moc * 0.8)),
    max: Math.ceil(moc),
  };
};

